var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fragment", [
    _c("div", { staticClass: "form-group" }, [
      _c(
        "div",
        { staticClass: "row" },
        [
          _c("div", { staticClass: "col-4" }, [
            _c(
              "label",
              { staticClass: "control-label", attrs: { for: "date" } },
              [
                _vm._v(
                  _vm._s(
                    _vm.resource("NewsroomItemCreateModel_Date_DisplayName")
                  )
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-8" },
            [
              _c("date-picker", {
                attrs: {
                  id: "date",
                  options: {
                    required: true,
                    typeable: false
                  }
                },
                model: {
                  value: _vm.dateValue,
                  callback: function($$v) {
                    _vm.dateValue = $$v
                  },
                  expression: "dateValue"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.$v.date.$dirty
            ? [
                !_vm.$v.date.required
                  ? _c("required-error-message", {
                      staticClass: "col-12",
                      attrs: {
                        "field-name": _vm.resource(
                          "NewsroomItemCreateModel_Date_DisplayName"
                        )
                      }
                    })
                  : _vm._e()
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c("div", { staticClass: "col-4" }, [
            _c(
              "label",
              { staticClass: "control-label", attrs: { for: "title" } },
              [
                _vm._v(
                  _vm._s(
                    _vm.resource("NewsroomItemCreateModel_Title_DisplayName")
                  )
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-8" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.titleValue,
                  expression: "titleValue"
                }
              ],
              staticClass: "form-control",
              attrs: { id: "title", type: "text" },
              domProps: { value: _vm.titleValue },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.titleValue = $event.target.value
                }
              }
            })
          ]),
          _vm._v(" "),
          _vm.$v.title.$dirty
            ? [
                !_vm.$v.title.required
                  ? _c("required-error-message", {
                      staticClass: "col-12",
                      attrs: {
                        "field-name": _vm.resource(
                          "NewsroomItemCreateModel_Title_DisplayName"
                        )
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.$v.title.maxLength
                  ? _c("max-length-exceeded-error-message", {
                      staticClass: "col-12",
                      attrs: {
                        "max-length": 255,
                        "field-name": _vm.resource(
                          "NewsroomItemCreateModel_Title_DisplayName"
                        )
                      }
                    })
                  : _vm._e()
              ]
            : _vm._e()
        ],
        2
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c(
        "div",
        { staticClass: "row" },
        [
          _c("div", { staticClass: "col-12" }, [
            _c(
              "label",
              { staticClass: "control-label", attrs: { for: "content" } },
              [
                _vm._v(
                  _vm._s(
                    _vm.resource("NewsroomItemCreateModel_Content_DisplayName")
                  )
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12" }, [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.contentValue,
                  expression: "contentValue"
                }
              ],
              staticClass: "form-control",
              attrs: { id: "content", rows: "6", cols: "20" },
              domProps: { value: _vm.contentValue },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.contentValue = $event.target.value
                }
              }
            })
          ]),
          _vm._v(" "),
          _vm.$v.content.$dirty
            ? [
                !_vm.$v.content.required
                  ? _c("required-error-message", {
                      staticClass: "col-12",
                      attrs: {
                        "field-name": _vm.resource(
                          "NewsroomItemCreateModel_Content_DisplayName"
                        )
                      }
                    })
                  : _vm._e()
              ]
            : _vm._e()
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }